import CarImg from "assets/classA-car.png";
import BagIcon from "assets/icons/luggage-outline.svg";
import { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { classActions } from "redux/slices/class";
import LocalStorage from "utils/localstorage.util";
import PersonIcon from "assets/icons/user-outline.svg";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { useTranslation } from "react-i18next";
import Button from "components/atoms/Button";

export default function ServiceClassTabs({ onSubmit }: any) {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const { t } = useTranslation("translation");

  const [current, setCurrent] = useState<any>();
  const bookingFormPayload = LocalStorage.getItem("BookingFormPayload");
  const classsPrice = useAppSelector((state) => state.classes.classsPrice);
  const classesPrices = useAppSelector((state) => state.classes.classesPrices);

  useEffect(() => {
    classesPrices.every((el, i) => {
      if (classsPrice) {
        if (el.class_id === classsPrice.class_id) {
          setCurrent(i);
          return false;
        }
      }
      return true;
    });
  }, [classsPrice, classesPrices]);

  useEffect(() => {
    if (!classsPrice && classesPrices?.length > 0) {
      setCurrent(0);
      dispatch(classActions.setClasssPrice(classesPrices[0]));
    }
  }, [classsPrice, classesPrices]);

  const handleClick = (classsPrice: any, index: any) => {
    if (classsPrice.notEnabled) return;
    setCurrent(index);
    dispatch(classActions.setClasssPrice(classsPrice));
    onSubmit();
  };


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <Grid container columnSpacing={8}>
        <Grid item xs={12} md={8}>
          {classesPrices.map((classPrice, index) => (
            <div
              className={`class-details ${
                classPrice.notEnabled ? "disabled-class-details" : ""
              }`}
              key={index}
              onClick={() => handleClick(classPrice, index)}
            >
              {classPrice && (
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item xs={12} md={5}>
                    <Box
                      display={"flex"}
                      alignItems={"flex-start"}
                      justifyContent={"space-between"}
                      className="class-common"
                    >
                      <div>
                        <h4>{classPrice.class_name}</h4>
                        <p>{classPrice.vehicle_name}</p>
                      </div>
                      <Stack direction={"row"} gap={2} alignContent={"center"}>
                        <div className="class-extras">
                          <img
                            className={
                              i18n.language === "ar" ? "service__arImg" : ""
                            }
                            loading="lazy"
                            src={PersonIcon}
                            alt=""
                          />
                          <p
                            className={
                              i18n.language === "ar" ? "classExtra__max" : ""
                            }
                          >
                            0{classPrice.max_persons}
                          </p>
                        </div>
                        <div className="class-extras">
                          <img
                            className={
                              i18n.language === "ar" ? "service__arImg" : ""
                            }
                            loading="lazy"
                            src={BagIcon}
                            alt=""
                          />
                          <p
                            className={
                              i18n.language === "ar" ? "classExtra__max" : ""
                            }
                          >
                            0{classPrice.max_bags}
                          </p>
                        </div>
                      </Stack>
                    </Box>
                    <div
                      className="class-img"
                      style={{
                        borderRadius: "12px",
                      }}
                    >
                      {classPrice.notEnabled && (
                        <Typography
                          top={0}
                          left={0}
                          padding={"2px 6px"}
                          borderRadius={"6px 6px 6px 0"}
                          color={"#FF1F30"}
                          position={"absolute"}
                          bgcolor={"#FFE3E5"}
                          fontSize={"12px"}
                        >
                          {t("this_class_are_allowed_minimum_duration_hours", {
                            hours: classPrice.min_hours_hourlyTrip,
                          })}
                        </Typography>
                      )}
                      <img
                        loading="lazy"
                        alt={classPrice.class_name}
                        src={classPrice.class_image || CarImg}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      gap={2}
                    >
                      <div className="class-common">
                        {classPrice.price_details.discount > 0 && (
                          <p
                            style={{
                              margin: 0,
                              ...(classPrice.price_details.discount > 0
                                ? {
                                    textDecoration:
                                      classPrice.price_details.discount > 0
                                        ? "line-through"
                                        : "",
                                    fontSize: "12px",
                                  }
                                : {}),
                            }}
                          >
                            {classPrice.price_details.originalGross.toFixed?.(
                              2
                            )}

                            {" " + classPrice.price_details.currency_sign}
                          </p>
                        )}
                        <h3
                          style={{
                            marginBottom: 0,
                            color: "#520A76",
                            lineHeight: "24px",
                          }}
                        >
                          {classPrice.price_details.brutto.toFixed?.(2)}
                          {" " + classPrice.price_details.currency_sign}
                        </h3>
                        <Typography
                          color={"#0A0A0E"}
                          fontSize={"12px"}
                          fontWeight={300}
                          component={"p"}
                          mb={"0px !important"}
                        >
                          &nbsp; {t("incl vat")}
                        </Typography>
                      </div>
                      <Button
                        className={i18n.language === "ar" ? "ltr-button-select-car" : "rtl-button-select-car"}
                        sx={{
                          height: "48px",
                          maxWidth: "140px",
                          position: "absolute",
                          bottom: "0",
                        }}
                        color="info"
                        disableElevation
                        variant="contained"
                        fullWidth
                      >
                        {t("selectCar")}
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </div>
          ))}
        </Grid>
        <Grid item xs={12} md={4}>
          <Stack gap={2} position={"sticky"} top={"182px"} mb={3}>
            <Box
              bgcolor={"#E9E9F0"}
              padding={"14px 16px"}
              borderRadius={"16px"}
            >
              <Typography fontWeight={700} fontSize={"16px"}>
                {t("All classes include")}
              </Typography>
              <ul
                style={{
                  padding: i18n.language === "ar" ? "0 16px 0 0" : "0 0 0 16px",
                }}
              >
                <li>
                  <p>{t("professionalChauffeur")}</p>
                </li>
                <li>
                  <p>
                    {bookingFormPayload?.pickup_type === "airport"
                      ? t("airportPickUp")
                      : t("freeWaitingTime")}
                  </p>
                </li>
                <li>
                  <p> {t("complimentaryWater")}</p>
                </li>
                <li>
                  <p>
                    {t("freeCancellation")}&nbsp;
                    {bookingFormPayload?.trip_type === "hourly"
                      ? "12"
                      : "4"}{" "}
                    {t("until")}
                  </p>
                </li>
              </ul>
            </Box>

            {/* <Stack
              gap={1.5}
              direction={"row"}
              alignItems={"center"}
              padding={"12px 16px"}
              borderRadius={"16px"}
              border={"1px solid #00AA63"}
              bgcolor={"rgba(0, 170, 99, 0.10)"}
            >
              <img src={ShieldIcon} alt="" />
              <Typography fontSize={"14px"} color={"#00AA63"} fontWeight={400}>
                {t("freeCancellation")}&nbsp;
                {bookingFormPayload?.trip_type === "hourly" ? "12" : "4"}{" "}
                {t("until")}
              </Typography>
            </Stack> */}

            {/* <Box>
              <Button
                sx={{
                  height: "50px",
                  borderRadius: "16px",
                }}
                color="info"
                disableElevation
                size="large"
                variant="contained"
                fullWidth
                type="submit"
                disabled={!classsPrice || classsPrice.notEnabled}
              >
                {t("select")}
              </Button>
            </Box> */}
          </Stack>
        </Grid>
      </Grid>
    </form>
  );
}
